import styled from "styled-components";

export const AuthContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
`;
